<ng-container *ngIf="sharedDataState$ | async as sharedDataState">
    <div class="content">
        <div class="table-container">
            <table mat-table matSort [dataSource]="dataSource" matSortActive="costUnit" matSortDirection="asc">
                <ng-container matColumnDef="costUnit">
                    <th mat-header-cell *matHeaderCellDef>
                        <mat-form-field subscriptSizing="dynamic">
                            <input matInput #filter (keyup)="applyFilter($event.target.value)" placeholder="Kostenträger suchen...">
                            <button mat-icon-button matSuffix aria-label="clear" *ngIf="filter.value" (click)="filter.value=''; applyFilter('');">
                                <mat-icon>close</mat-icon>
                            </button>
                        </mat-form-field>
                    </th>
                    <td mat-cell *matCellDef="let data">
                        {{sharedDataState.costUnitLookup[data.costUnitId].name}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="articleNr">
                    <th mat-header-cell *matHeaderCellDef>{{ "app.model.cost-unit.articleNr.label" | translate }}</th>
                    <td mat-cell *matCellDef="let data">
                        {{sharedDataState.costUnitLookup[data.costUnitId].articleNr}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="revenue">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before">{{ "app.model.cost-unit-contribution-margin.revenue.label" | translate }}</th>
                    <td mat-cell *matCellDef="let data">
                        {{data.revenue / 100 | currency:'EUR':'symbol':'1.2-2'}}

                    </td>
                </ng-container>

                <ng-container matColumnDef="variableCost">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before">{{ "app.model.cost-unit-contribution-margin.variableCost.label" | translate }}</th>
                    <td mat-cell *matCellDef="let data">
                        {{data.variableCost / 100 | currency:'EUR':'symbol':'1.2-2'}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="contributionMarginLevel1">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before">{{ "app.model.cost-unit-contribution-margin.db1.label" | translate }}</th>
                    <td mat-cell *matCellDef="let data">
                        {{data.contributionMarginLevel1 / 100 | currency:'EUR':'symbol':'1.2-2'}}
                    </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: columns;"></tr>
            </table>
        </div>
    </div>

</ng-container>
